import ProfileImg from "../assets/Group 62904.png";
const Review = [
  {
    id: 1,
    profileImg: { ProfileImg },
    name: "David Fauser,",
    position: "Director of Sales, CIMCO Refrigeration",
    company: "Company",
    feedback:
      "Brigade Plus transforms sales management and customer journeys with Zoho CRM",
    video: "false",
  },
  {
    id: 2,
    profileImg: { ProfileImg },
    name: "David Fauser,",
    position: "Director of Sales, CIMCO Refrigeration",
    company: "Company",
    feedback:
      "Brigade Plus transforms sales management and customer journeys with Zoho CRM",
    video: "true",
  },
  {
    id: 3,
    profileImg: { ProfileImg },
    name: "David Fauser,",
    position: "Director of Sales, CIMCO Refrigeration",
    company: "Company",
    feedback:
      "Brigade Plus transforms sales management and customer journeys with Zoho CRM",
    video: "true",
  },
  {
    id: 4,
    profileImg: { ProfileImg },
    name: "David Fauser,",
    position: "Director of Sales, CIMCO Refrigeration",
    company: "Company",
    feedback:
      "Brigade Plus transforms sales management and customer journeys with Zoho CRM",
    video: "false",
  },
  {
    id: 5,
    profileImg: { ProfileImg },
    name: "David Fauser,",
    position: "Director of Sales, CIMCO Refrigeration",
    company: "Company",
    feedback:
      "Brigade Plus transforms sales management and customer journeys with Zoho CRM",
    video: "false",
  },
  {
    id: 6,
    profileImg: { ProfileImg },
    name: "David Fauser,",
    position: "Director of Sales, CIMCO Refrigeration",
    company: "Company",
    feedback:
      "Brigade Plus transforms sales management and customer journeys with Zoho CRM",
    video: "false",
  },
  {
    id: 7,
    profileImg: { ProfileImg },
    name: "David Fauser,",
    position: "Director of Sales, CIMCO Refrigeration",
    company: "Company",
    feedback:
      "Brigade Plus transforms sales management and customer journeys with Zoho CRM",
    video: "false",
  },
  {
    id: 8,
    profileImg: { ProfileImg },
    name: "David Fauser,",
    position: "Director of Sales, CIMCO Refrigeration",
    company: "Company",
    feedback:
      "Brigade Plus transforms sales management and customer journeys with Zoho CRM",
    video: "false",
  },
  {
    id: 9,
    profileImg: { ProfileImg },
    name: "David Fauser,",
    position: "Director of Sales, CIMCO Refrigeration",
    company: "Company",
    feedback:
      "Brigade Plus transforms sales management and customer journeys with Zoho CRM",
    video: "true",
  },
];

export default Review;
